'use client';
import { __styles as vanillaStyles } from '@griffel/core';
import { insertionFactory } from './insertionFactory.js';
import { useRenderer } from './RendererContext.js';
import { useTextDirection } from './TextDirectionContext.js';
/**
 * A version of makeStyles() that accepts build output as an input and skips all runtime transforms.
 *
 * @private
 */
export function __styles(classesMapBySlot, cssRules) {
    const getStyles = vanillaStyles(classesMapBySlot, cssRules, insertionFactory);
    return function useClasses() {
        const dir = useTextDirection();
        const renderer = useRenderer();
        return getStyles({ dir, renderer });
    };
}
//# sourceMappingURL=__styles.js.map